<template>
  <div class="equiry">
    <!-- 头部 -->
    <v-header></v-header>
    <!-- 广告 -->
    <div class="banner">
      <div class="center">
        <h1>{{ $t("message.event.bannerh1") }}</h1>
        <p>{{ $t("message.event.bannerh2") }}</p>
        <el-button type="success" @click="dialogVisible = true">{{
          $t("message.event.bannerbtn")
        }}</el-button>
      </div>
      <!-- <el-dialog :visible.sync="dialogVisible" width="900px" >
        <el-form :label-position="labelPosition" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" size="mini">
          <p class="banner-call1">{{$t('message.event.dialog.h1')}}</p>
          <el-form-item :label="$t('message.event.dialog.namelabel')" prop="name">
            <el-input :placeholder="$t('message.event.dialog.nameplaceholder')" v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.event.dialog.emaillabel')" prop="email" >
            <el-input :placeholder="$t('message.event.dialog.emailplaceholder')" v-model="ruleForm.email"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.event.dialog.phonelabel')" prop="phone">
            <el-input :placeholder="$t('message.event.dialog.phoneplaceholder')" v-model="ruleForm.phone"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.event.dialog.conlabel')" prop="con">
            <el-input v-model="ruleForm.con" :placeholder="$t('message.event.dialog.conplaceholder')"></el-input>
          </el-form-item>
          <p class="banner-call1">{{$t('message.event.dialog.h2')}}</p>
          <el-form-item :label="$t('message.event.dialog.date1label')" prop="date1">
            <el-date-picker type="date" :placeholder="$t('message.event.dialog.date1placeholder')" :picker-options="pickerOptions0" v-model="ruleForm.date1" style="width: 100%;"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('message.event.dialog.date2label')" prop="date2">
            <el-input :placeholder="$t('message.event.dialog.date2placeholder')" v-model="ruleForm.date2" style="width: 100%;"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.event.dialog.locationlabel')" prop="location">
            <el-input :placeholder="$t('message.event.dialog.locationplaceholder')" v-model="ruleForm.location"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.event.dialog.numberlabel')" prop="number">
            <el-input-number v-model="ruleForm.number"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('message.event.dialog.budgetlabel')" prop="budget">
            <el-input :placeholder="$t('message.event.dialog.budgetplaceholder')" v-model="ruleForm.budget"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.event.dialog.foodlabel')" prop="food">
            <el-input v-model="ruleForm.food" :placeholder="$t('message.event.dialog.foodplaceholder')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.event.dialog.region1label')" prop="region1">
            <el-input v-model="ruleForm.region1" :placeholder="$t('message.event.dialog.region1placeholder')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.event.dialog.Drinklabel')" prop="Drink">
            <el-input v-model="ruleForm.Drink" :placeholder="$t('message.event.dialog.Drinkplaceholder')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.event.dialog.Waiterlabel')" prop="Waiter">
            <el-input v-model="ruleForm.Waiter" :placeholder="$t('message.event.dialog.Waiterplaceholder')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.event.dialog.region2label')" prop="region2">
            <el-input v-model="ruleForm.region2" :placeholder="$t('message.event.dialog.region2placeholder')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.event.dialog.Claimlabel')" prop="Claim">
            <el-input v-model="ruleForm.Claim" :placeholder="$t('message.event.dialog.Claimplaceholder')"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <a :href=href style="color:#fff;text-decoration:none" @click="show('ruleForm')"><el-button type="primary" >{{$t('message.event.dialog.btn1')}}</el-button></a>
          <el-button @click="dialogVisible = false">{{$t('message.event.dialog.btn2')}}</el-button>
        </span>
      </el-dialog>-->
      <el-dialog :visible.sync="dialogVisible" width="900px">
        <el-form
          :label-position="labelPosition"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          size="mini"
        >
          <p class="banner-call1">{{ $t("message.dialog.title1") }}</p>
          <el-form-item :label="$t('message.dialog.name')" prop="name">
            <el-input
              :placeholder="$t('message.dialog.names')"
              v-model="ruleForm.name"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.email')" prop="email">
            <el-input
              :placeholder="$t('message.dialog.emails')"
              v-model="ruleForm.email"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.phone')" prop="phone">
            <el-input
              :placeholder="$t('message.dialog.phones')"
              v-model="ruleForm.phone"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.company')" prop="con">
            <el-input
              v-model="ruleForm.con"
              :placeholder="$t('message.dialog.companys')"
            ></el-input>
          </el-form-item>
          <p class="banner-call1">{{ $t("message.dialog.title2") }}</p>
          <el-form-item :label="$t('message.dialog.eventDate')" prop="date1">
            <el-date-picker
              type="date"
              :placeholder="$t('message.dialog.eventDates')"
              :picker-options="pickerOptions0"
              v-model="ruleForm.date1"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.eventTime')" prop="date2">
            <!-- <el-input
              :placeholder="$t('message.dialog.eventTimes')"
              v-model="ruleForm.date2"
              style="width: 100%"
            ></el-input> -->
            <!-- <el-time-select
              v-model="ruleForm.date2"
              is-range
              :picker-options="{
                start: '10:00',
                step: '00:30',
                end: '20:00',
              }"
              :placeholder="$t('message.dialog.eventTimes')"
              style="width: 100%"
            >
            </el-time-select> -->
            <el-select
              v-model="ruleForm.date2"
              :placeholder="$t('message.dialog.eventTimes')"
              style="width: 100%"
            >
              <el-option-group
                v-for="group in options"
                :key="group.label"
                :label="group.label"
              >
                <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('message.dialog.eventyLocation')"
            prop="location"
          >
            <el-input
              :placeholder="$t('message.dialog.eventyLocations')"
              v-model="ruleForm.location"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('message.dialog.eumberOfGuests')"
            prop="number"
          >
            <el-input-number v-model="ruleForm.number"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.budget')" prop="budget">
            <el-input
              :placeholder="$t('message.dialog.budgets')"
              v-model="ruleForm.budget"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.requiredFoods')" prop="food">
            <el-input
              v-model="ruleForm.food"
              :placeholder="$t('message.dialog.requiredFoods')"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('message.dialog.servingstyle')"
            prop="region1"
          >
            <el-input
              v-model="ruleForm.region1"
              :placeholder="$t('message.dialog.servingstyles')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.bervage')" prop="Drink">
            <el-input
              v-model="ruleForm.Drink"
              :placeholder="$t('message.dialog.bervages')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.waiters')" prop="Waiter">
            <el-input
              v-model="ruleForm.Waiter"
              :placeholder="$t('message.dialog.waiterss')"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('message.dialog.requiredEquipment')"
            prop="region2"
          >
            <el-input
              v-model="ruleForm.region2"
              :placeholder="$t('message.dialog.requiredEquipments')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.otherRemarks')" prop="Claim">
            <el-input
              v-model="ruleForm.Claim"
              :placeholder="$t('message.dialog.otherRemarkss')"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <a
            :href="href"
            style="color: #fff; text-decoration: none"
            @click="show('ruleForm')"
          >
            <el-button type="primary">{{
              $t("message.dialog.confirm")
            }}</el-button>
          </a>
          <el-button @click="dialogVisible = false">{{
            $t("message.dialog.cancel")
          }}</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 服务 -->
    <div class="service">
      <div class="center">
        <h2>{{ $t("message.event.contenth1") }}</h2>
        <p>{{ $t("message.event.contentp1") }}</p>
        <div class="service-d">
          <div>
            <div>
              <div>
                <img
                  src="../assets/images/pc_hd_icon1.png"
                  alt
                  width="218"
                  height="218"
                />
              </div>
              <div>
                <h3>{{ $t("message.event.contentspan1") }}</h3>
                <p style="font-size: 15px; font-weight: normal; color: #515154">
                  {{ $t("message.event.contentsam1") }}
                </p>
              </div>
            </div>
          </div>
          <div>
            <div>
              <div>
                <img
                  src="../assets/images/pc_hd_icon2.png"
                  alt
                  width="218"
                  height="218"
                />
              </div>
              <div>
                <h3>{{ $t("message.event.contentspan2") }}</h3>
                <p style="font-size: 15px; font-weight: normal; color: #515154">
                  {{ $t("message.event.contentsam2") }}
                </p>
              </div>
            </div>
          </div>
          <div>
            <div>
              <div>
                <img
                  src="../assets/images/pc_hd_icon3.png"
                  alt
                  width="218"
                  height="218"
                />
              </div>
              <div>
                <h3>{{ $t("message.event.contentspan3") }}</h3>
                <p style="font-size: 15px; font-weight: normal; color: #515154">
                  {{ $t("message.event.contentsam4") }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <el-button type="success" @click="dialogVisible = true">{{
          $t("message.event.bannerbtn")
        }}</el-button>
      </div>
    </div>
    <div class="servicemo">
      <div class="center">
        <h2>
          <img src="../assets/images/hd_icon_rec.png" alt />
          {{ $t("message.event.contenth1") }}
        </h2>
        <p>{{ $t("message.event.contentp1") }}</p>
        <div class="service-d">
          <div>
            <div class="service-dd">
              <div>
                <img
                  src="../assets/images/pc_hd_icon1.png"
                  alt
                  width="100%"
                  height="100%"
                />
              </div>
              <div>
                <h3>{{ $t("message.event.contentspan1") }}</h3>
                <p>{{ $t("message.event.contentsam1") }}</p>
              </div>
            </div>
          </div>
          <div>
            <div class="service-dd">
              <div>
                <img
                  src="../assets/images/pc_hd_icon2.png"
                  alt
                  width="100%"
                  height="100%"
                />
              </div>
              <div>
                <h3>{{ $t("message.event.contentspan2") }}</h3>
                <p>{{ $t("message.event.contentsam2") }}</p>
              </div>
            </div>
          </div>
          <div>
            <div class="service-dd">
              <div>
                <img
                  src="../assets/images/pc_hd_icon3.png"
                  alt
                  width="100%"
                  height="100%"
                />
              </div>
              <div>
                <h3>{{ $t("message.event.contentspan3") }}</h3>
                <p>{{ $t("message.event.contentsam4") }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="servicebtn">
          <el-button type="success" @click="dialogVisible = true">{{
            $t("message.event.bannerbtn")
          }}</el-button>
        </div>
      </div>
    </div>
    <!-- 选项 -->
    <div class="change">
      <el-tabs v-model="activeName" stretch>
        <el-tab-pane
          :label="$t('message.event.changetitle1')"
          name="Christmas Parties"
        >
          <div class="row">
            <div class="row-l">
              <img
                src="../assets/images/pc_hd_activity1_img.png"
                alt
                width="100%"
              />
            </div>
            <div class="row-r">
              <div>
                <img
                  src="../assets/images/pc_hd_activity1_content1_img.png"
                  alt
                  width="100%"
                />
                <div class="figure-text clearfix">
                  <h5>{{ $t("message.event.change1") }}</h5>
                </div>
              </div>
              <div>
                <img
                  src="../assets/images/pc_hd_activity1_content2_img.png"
                  alt
                  width="100%"
                />
                <div class="figure-text clearfix">
                  <h5>{{ $t("message.event.change2") }}</h5>
                </div>
              </div>
              <div>
                <img
                  src="../assets/images/pc_hd_activity1_content3_img.png"
                  alt
                  width="100%"
                />
                <div class="figure-text clearfix">
                  <h5>{{ $t("message.event.change3") }}</h5>
                </div>
              </div>
              <div>
                <img
                  src="../assets/images/pc_hd_activity1_content4_img.png"
                  alt
                  width="100%"
                />
                <div class="figure-text clearfix">
                  <h5>{{ $t("message.event.change4") }}</h5>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="$t('message.event.changetitle2')"
          name="Annual Dinner"
        >
          <div class="row">
            <div class="row-l">
              <img
                src="../assets/images/pc_hd_activity2_img.png"
                alt
                width="100%"
              />
            </div>
            <div class="row-r">
              <div>
                <img
                  src="../assets/images/pc_hd_activity2_content1_img.png"
                  alt
                  width="100%"
                  height="153"
                />
                <div class="figure-text clearfix">
                  <h5>{{ $t("message.event.change5") }}</h5>
                </div>
              </div>
              <div>
                <img
                  src="../assets/images/pc_hd_activity2_content2_img.png"
                  alt
                  width="100%"
                />
                <div class="figure-text clearfix">
                  <h5>{{ $t("message.event.change6") }}</h5>
                </div>
              </div>
              <div>
                <img
                  src="../assets/images/pc_hd_activity2_content3_img.png"
                  alt
                  width="100%"
                />
                <div class="figure-text clearfix">
                  <h5>{{ $t("message.event.change7") }}</h5>
                </div>
              </div>
              <div>
                <img
                  src="../assets/images/pc_hd_activity2_content4_img.png"
                  alt
                  width="100%"
                />
                <div class="figure-text clearfix">
                  <h5>{{ $t("message.event.change8") }}</h5>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('message.event.changetitle3')" name="Events">
          <div class="row">
            <div class="row-l">
              <img
                src="../assets/images/pc_hd_activity3_img.png"
                alt
                width="100%"
              />
            </div>
            <div class="row-r">
              <div>
                <img
                  src="../assets/images/pc_hd_activity3_content1_img.png"
                  alt
                  width="100%"
                />
                <div class="figure-text clearfix">
                  <h5>{{ $t("message.event.change9") }}</h5>
                </div>
              </div>
              <div>
                <img
                  src="../assets/images/pc_hd_activity3_content2_img.png"
                  alt
                  width="100%"
                />
                <div class="figure-text clearfix">
                  <h5>{{ $t("message.event.change10") }}</h5>
                </div>
              </div>
              <div>
                <img
                  src="../assets/images/pc_hd_activity3_content3_img.png"
                  alt
                  width="100%"
                />
                <div class="figure-text clearfix">
                  <h5>{{ $t("message.event.change11") }}</h5>
                </div>
              </div>
              <div>
                <img
                  src="../assets/images/pc_hd_activity3_content4_img.png"
                  alt
                  width="100%"
                />
                <div class="figure-text clearfix">
                  <h5>{{ $t("message.event.change12") }}</h5>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="$t('message.event.changetitle4')"
          name="Conferences"
        >
          <div class="row">
            <div class="row-l">
              <img
                src="../assets/images/pc_hd_activity4_img.png"
                alt
                width="100%"
              />
            </div>
            <div class="row-r">
              <div>
                <img
                  src="../assets/images/pc_hd_activity4_content1_img.png"
                  alt
                  width="100%"
                />
                <div class="figure-text clearfix">
                  <h5>{{ $t("message.event.change13") }}</h5>
                </div>
              </div>
              <div>
                <img
                  src="../assets/images/pc_hd_activity4_content2_img.png"
                  alt
                  width="100%"
                />
                <div class="figure-text clearfix">
                  <h5>{{ $t("message.event.change14") }}</h5>
                </div>
              </div>
              <div>
                <img
                  src="../assets/images/pc_hd_activity4_content3_img.png"
                  alt
                  width="100%"
                />
                <div class="figure-text clearfix">
                  <h5>{{ $t("message.event.change15") }}</h5>
                </div>
              </div>
              <div>
                <img
                  src="../assets/images/pc_hd_activity4_content4_img.png"
                  alt
                  width="100%"
                />
                <div class="figure-text clearfix">
                  <h5>{{ $t("message.event.change16") }}</h5>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- 轮播 -->
      <div class="move">
        <el-carousel height="264px">
          <el-carousel-item>
            <p style="text-align: left; margin: 0 0 5% 10%">大型活動</p>
            <img
              src="../assets/images/parties1.png"
              alt
              width="100%"
              height="100%"
            />
          </el-carousel-item>
          <el-carousel-item>
            <p style="text-align: left; margin: 0 0 5% 10%">商務活動</p>
            <img
              src="../assets/images/dinner1.png"
              alt
              width="100%"
              height="100%"
            />
          </el-carousel-item>
          <el-carousel-item>
            <p style="text-align: left; margin: 0 0 5% 10%">週年活動</p>
            <img
              src="../assets/images/events1.png"
              alt
              width="100%"
              height="100%"
            />
          </el-carousel-item>
          <el-carousel-item>
            <p style="text-align: left; margin: 0 0 5% 10%">午餐會議</p>
            <img
              src="../assets/images/con1.png"
              alt
              width="100%"
              height="100%"
            />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- 頁尾 -->
  </div>
</template>

<script>
import $ from "jquery";
import header from "../components/header";
export default {
  name: "index",
  data() {
    return {
      href: "",
      pickerOptions0: {
        disabledDate:(time)=>{
                return time.getTime() < Date.now() - 8.64e7;
            }
      },
      activeName: "Christmas Parties",
      i: true,
      dialogVisible: false,
      labelPosition: "right",
      ruleForm: {
        name: "",
        email: "",
        phone: "",
        con: "",
        date1: "",
        date2: "",
        location: "",
        number: "",
        budget: "",
        food: "",
        Drink: "",
        Waiter: "",
        Claim: "",
        region1: "",
        region2: "",
      },
      options: [
        {
          label: "請留意食物到達時間一般為前後30分鐘",
          options: [
            {
              value: "10:00 - 10:30",
              label: "10:00 - 10:30",
            },
            {
              value: "10:30 - 11:00",
              label: "10:30 - 11:00",
            },
            {
              value: "11:00 - 11:30",
              label: "11:00 - 11:30",
            },
            {
              value: "11:30 - 12:00",
              label: "11:30 - 12:00",
            },
            {
              value: "12:00 - 12:30",
              label: "12:00 - 12:30",
            },
            {
              value: "12:30 - 13:00",
              label: "12:30 - 13:00",
            },
            {
              value: "13:00 - 13:30",
              label: "13:00 - 13:30",
            },
            {
              value: "13:30 - 14:00",
              label: "13:30 - 14:00",
            },
            {
              value: "14:00 - 14:30",
              label: "14:00 - 14:30",
            },
            {
              value: "14:30 - 15:00",
              label: "14:30 - 15:00",
            },
            {
              value: "15:00 - 15:30",
              label: "15:00 - 15:30",
            },
            {
              value: "15:30 - 16:00",
              label: "15:30 - 16:00",
            },
            {
              value: "16:00 - 16:30",
              label: "16:00 - 16:30",
            },
            {
              value: "16:30 - 17:00",
              label: "16:30 - 17:00",
            },
            {
              value: "17:00 - 17:30",
              label: "17:00 - 17:30",
            },
            {
              value: "17:30 - 18:00",
              label: "17:30 - 18:00",
            },
            {
              value: "18:00 - 18:30",
              label: "18:00 - 18:30",
            },
            {
              value: "18:30 - 19:00",
              label: "18:30 - 19:00",
            },
            {
              value: "19:00 - 19:30",
              label: "19:00 - 19:30",
            },
            {
              value: "19:30 - 20:00",
              label: "19:30 - 20:00",
            },
          ],
        },
      ],
      // options: [
      //   {
      //     value: "10:00 - 10:30",
      //     label: "10:00 - 10:30",
      //   },
      //   {
      //     value: "10:30 - 11:00",
      //     label: "10:30 - 11:00",
      //   },
      //   {
      //     value: "11:00 - 11:30",
      //     label: "11:00 - 11:30",
      //   },
      //   {
      //     value: "11:30 - 12:00",
      //     label: "11:30 - 12:00",
      //   },
      //   {
      //     value: "12:00 - 12:30",
      //     label: "12:00 - 12:30",
      //   },
      //   {
      //     value: "12:30 - 13:00",
      //     label: "12:30 - 13:00",
      //   },
      //   {
      //     value: "13:00 - 13:30",
      //     label: "13:00 - 13:30",
      //   },
      //   {
      //     value: "13:30 - 14:00",
      //     label: "13:30 - 14:00",
      //   },
      //   {
      //     value: "14:00 - 14:30",
      //     label: "14:00 - 14:30",
      //   },
      //   {
      //     value: "14:30 - 15:00",
      //     label: "14:30 - 15:00",
      //   },
      //   {
      //     value: "15:00 - 15:30",
      //     label: "15:00 - 15:30",
      //   },
      //   {
      //     value: "15:30 - 16:00",
      //     label: "15:30 - 16:00",
      //   },
      //   {
      //     value: "16:00 - 16:30",
      //     label: "16:00 - 16:30",
      //   },
      //   {
      //     value: "16:30 - 17:00",
      //     label: "16:30 - 17:00",
      //   },
      //   {
      //     value: "17:00 - 17:30",
      //     label: "17:00 - 17:30",
      //   },
      //   {
      //     value: "17:30 - 18:00",
      //     label: "17:30 - 18:00",
      //   },
      //   {
      //     value: "18:00 - 18:30",
      //     label: "18:00 - 18:30",
      //   },
      //   {
      //     value: "18:30 - 19:00",
      //     label: "18:30 - 19:00",
      //   },
      //   {
      //     value: "19:00 - 19:30",
      //     label: "19:00 - 19:30",
      //   },
      //   {
      //     value: "19:30 - 20:00",
      //     label: "19:30 - 20:00",
      //   },
      // ],
      rules: {
        name: [
          { required: true, message: "請輸入您的稱呼", trigger: "blur" },
          { min: 1, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        email: [
          { required: true, message: "請輸入電郵", trigger: "blur" },
          { type: "email", message: "格式不對", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "請輸入聯絡方式", trigger: "blur" },
          {
            pattern: /^[1][3-8]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/,
            message: "請輸入正確的手機號碼格式",
          },
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "請選擇日期",
            trigger: "change",
          },
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "請選擇時間",
            trigger: "change",
          },
        ],
        location: [
          { required: true, message: "請輸入活動地點", trigger: "blur" },
        ],
        number: [
          { required: true, message: "請輸入貴賓人數", trigger: "blur" },
        ],
        budget: [{ required: true, message: "請輸入預算", trigger: "blur" }],
        food: [{ required: true, message: "請輸入所需食物", trigger: "blur" }],
      },
    };
  },
  methods: {
    chil () {
      if (this.i === true) {
        $(".phone-header-top").css("overflow", "inherit");
        this.i = false;
      } else if (this.i === false) {
        $(".phone-header-top").css("overflow", "hidden");
        this.i = true;
      }
    },
    show(formName) {
      this.href =
        "https://api.whatsapp.com/send?phone=85264586539&text=hello%20到會家,我想瞭解一些合作的相關事宜%0A稱呼:" +
        this.ruleForm.name +
        "%0A電郵：" +
        this.ruleForm.email +
        "%0A電話：" +
        this.ruleForm.phone +
        "%0A公司：" +
        this.ruleForm.con +
        "%0A日期：" +
        this.$moment(this.ruleForm.date1).format("YYYY-MM-DD") +
        "%0A時間：" +
        this.ruleForm.date2 +
        "%0A地點：" +
        this.ruleForm.location +
        "%0A貴賓人數：" +
        this.ruleForm.number +
        "%0A預算：" +
        this.ruleForm.budget +
        "%0A所需食物：" +
        this.ruleForm.food +
        "%0A食物供應形式：" +
        this.ruleForm.region1 +
        "%0A飲品：" +
        this.ruleForm.Drink +
        "%0A待應生：" +
        this.ruleForm.Waiter +
        "%0A設備要求：" +
        this.ruleForm.region2 +
        "%0A特別要求/安排：" +
        this.ruleForm.Claim +
        "！😋";
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          return false;
        }
      });
    },
  },
  components: {
    "v-header": header,
  },
};
</script>

<style scoped>
/* 页头 */
.move,
.servicemo {
  display: none;
}
.center {
  width: 80%;
  height: 100%;
  margin: auto;
  overflow: hidden;
}
.h-bottom-l ul,
.h-bottom-r > span {
  font-size: 0.85rem;
  color: #eb6410;
}
.h-bottom-r .el-button.el-button--success {
  color: white;
}
/* 广告 */
.banner .el-button.el-button--success {
  display: block;
  width: 20rem;
  margin: 2% auto 0 auto;
  background: #eb6410;
  border: 1px solid #eb6410;
}
.banner {
  /* position: relative; */
  padding: 10% 0;
  background: url("../assets/images/pc_hd_banner_bg.png") no-repeat;
  background-size: 100% 100%;
  margin: 110px 0;
}
.banner .el-dialog {
  margin-top: 12vh !important;
}
.banner .el-dialog__body {
  padding: 0 33px 0 0 !important;
}
.banner h1,
.banner p {
  text-align: center;
  color: #eb6410;
}
.banner h1 {
  font-weight: bold;
  font-size: 50px;
}
.banner p {
  margin: 1% 0;
  font-size: 15px;
}
.el-scrollbar__view.el-time-spinner__list li,
.el-scrollbar__view.el-select-dropdown__list li {
  display: block;
}
.banner .center {
  width: 80%;
  height: 40%;
  /* position: absolute; */
  left: 0;
  top: 25px;
  right: 0;
  bottom: 0;
  z-index: 3;
  margin: auto;
}
.banner .banner-call1 {
  font-weight: 200;
  color: #eb6410;
  letter-spacing: 0;
  margin: 0 0 3% 0;
  font-size: 1.1rem;
}
/* 选择 */
.change {
  width: 80%;
  margin: 3% auto;
}
.el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav {
  width: 1180px;
  display: flex;
  justify-content: space-around;
}
.el-tabs__item:hover {
  color: #eb6410 !important;
  cursor: pointer;
}
.el-tabs__active-bar {
  background-color: #eb6410 !important;
}
.el-tabs__item.is-active {
  color: #eb6410 !important;
}
.row {
  margin-right: -0.9375rem;
  margin-left: -0.9375rem;
}
.row:before,
.row:after {
  display: table;
  content: " ";
}
.row-l,
.row-r {
  width: 50%;
  float: left;
}
.row-r > div {
  width: 45%;
  float: left;
  margin: 0 2% 5%;
}
.figure-text {
  height: 15px;
  text-align: left;
  display: block;
  border-radius: 0 0 3px 3px;
  background: #fff;
  padding: 16px 20px;
  border: 1px solid #dfe0e0;
  border-top: none;
  box-shadow: 0px 1px 2px 0px rgba(20, 20, 21, 0.05);
}
.figure-text h5 {
  font-size: 15px;
  color: #141415;
  margin-bottom: 0;
  font-family: "geomanist_regularregular", sans-serif;
  font-weight: normal;
  float: left;
  line-height: 15px;
}
/* 服务 */
.service {
  background: #fff;
}
.service h2,
.service p {
  text-align: center;
}
.service h2 {
  font-size: 20px;
  font-family: "geomanistbook", sans-serif;
  font-weight: 500;
  color: #141415;
  margin: 5% 0 1% 0;
}
.service p {
  color: #919599;
  font-size: 14px;
  margin: 0 0 5% 0;
}
.service-d {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
}
.service-d > div {
  width: 27%;
  margin: 0 1%;
  padding: 4% 2% 1% 2%;
  box-shadow: 1px 1px 10px #888e95;
}
.service-d > div {
  text-align: center;
}
.service-d h3 {
  font-weight: 500;
  font-size: 17px;
  color: #141415;
  line-height: 25px;
  margin: 3% 0;
}
.service .el-button.el-button--success {
  display: block;
  margin: 3% auto;
  background: #eb6410;
  border: 1px solid #eb6410;
}
.v-modal {
  display: none;
}
/* 合作 */
.Cooperation p {
  text-align: center;
  color: #95989d;
  font-size: 1.09375rem;
  font-weight: 300;
  margin-top: 0;
  margin-bottom: 1rem;
}
/* 頁尾 */
footer {
  margin: 3% 0 0 0;
  height: 10rem;
  background: black;
}
footer > div > div {
  margin: 2% 0 0 0;
  color: #95989d;
  font-size: 0.75rem;
  font-weight: 400;
  margin-bottom: 1rem;
  text-align: center;
}
.el-button--success:hover {
  background: #eb6410;
  border-color: #eb6410;
}
/* 移动端 */
@media (max-width: 820px) {
  .service {
    display: none;
  }
  .servicemo {
    display: block;
  }
  .servicemo h2 {
    margin: 10px 0 0 10px;
    font-size: 16px;
  }
  .servicemo .center > p {
    margin: 10px 0 10px 18px;
    font-size: 13px;
    color: #919599;
  }
  .servicemo .service-d > div {
    height: 150px;
    margin: 15px 15px;
  }
  .service-dd {
    overflow: hidden;
  }
  .service-dd h3 {
    font-size: 18px;
    text-align: left;
  }
  .service-dd p {
    font-size: 13px;
    text-align: left;
  }
  .service-dd > div {
    float: left;
  }
  .service-dd > div:nth-child(1) {
    width: 30%;
  }
  .service-dd > div:nth-child(1) > img {
    padding: 15px 10px;
  }
  .service-dd > div:nth-child(2) {
    width: 70%;
    padding: 20px 10px 20px 40px;
    box-sizing: border-box;
    color: #919599;
  }
  .servicebtn {
    text-align: center;
  }
  .servicebtn > button {
    background: #eb6410;
    border: 1px solid #eb6410;
    cursor: pointer;
  }

  .banner {
    background: url("../assets/images/hd_banner_bg.png");
    background-size: 100% 100%;
  }
  .banner .el-dialog {
    margin-top: 60px !important;
  }
  .change {
    margin: 10% 0;
  }
  .move {
    display: block;
  }
  .equiry .change > div:nth-child(1) {
    display: none;
  }
  .center {
    width: 100%;
  }
  .parameter {
    height: 120px;
  }
  .parameter ul {
    transform: translate(0, 0%);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .parameter ul li {
    text-align: center;
    flex: 1 1 30%;
    margin: 3% 0;
  }
  .parameter li span:nth-child(1) {
    display: block;
    margin: auto;
    float: none;
  }
  .parameter li span:nth-child(2),
  .parameter li span:nth-child(3) {
    font-size: 12px;
    width: 100%;
    padding: 0;
  }
  .parameter li span:nth-child(3) {
    font-size: 12px;
  }
  .banner .center {
    width: 95%;
    height: 85%;
  }
  .banner .center h1 {
    font-size: 1rem;
  }
  .banner .el-button.el-button--success {
    display: block;
    width: 14rem;
    margin: 5% auto 0 auto;
  }
  .change {
    width: 100%;
  }
  .banner {
    margin: 135px 0 0 0;
  }
  .service-d {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    text-align: center;
  }
  .service h2 {
    font-size: 25px;
  }
  .service p {
    font-size: 14px;
    padding: 0 4%;
  }
  .service-d > div {
    width: 100%;
  }
  .parameter2 li span:nth-child(2) {
    font-size: 12px;
  }
  .parameter2 li span:nth-child(1) {
    margin: 0 0 0 38%;
  }
}
</style>
<style>
.equiry .el-dialog__body label {
  width: 140px !important;
}
.equiry .el-form-item__content {
  margin-left: 140px !important;
}
@media (max-width: 820px) {
  .equiry .el-button.servicebtn.el-button--success {
    text-align: center;
  }
  .equiry .el-dialog__header {
    position: fixed;
    right: 0;
    width: 100%;
    height: 35px;
    background: #fff;
    z-index: 100;
    padding: 0;
  }
  .equiry .el-dialog {
    width: 100% !important;
    margin: 0 !important;
  }
  .equiry .el-carousel__indicators--horizontal {
    display: none;
  }
  .equiry .el-dialog__body {
    padding: 35px 20px 35px 0;
  }
}
.equiry .el-dialog__footer {
  text-align: center !important;
}
.equiry .el-button.el-button--primary {
  border: 1px solid #eb6410;
  background: #eb6410;
}
.el-scrollbar__view.el-time-spinner__list li {
  display: block;
}
.el-dialog__footer {
  text-align: center;
}
.el-form-item__label {
  font-size: 13px !important;
}
</style>
